import { getOperationName } from "../parsers/getOperationName";

/**
 * Creates an operation object
 */
export const Operation = (query, variables = {}) => {
	const body = typeof query === "function" ? query(variables) : query;
	const operationName = getOperationName(body) || undefined;

	return {
		operationName,
		query: body,
		variables,
	};
};

export const removeOperationName = query =>
	query.replace(
		/(query|mutation)\s+([^({\s]*)/m, //
		"$1",
	);
